"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BlueprintOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M28,4H8V3A1,1,0,0,0,7,2H6A4,4,0,0,0,2,5.8,1.27,1.27,0,0,0,2,6V26a4,4,0,0,0,4,4H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM4,6A2,2,0,0,1,6,4V22a3.91,3.91,0,0,0-2,.56ZM28,28H6a2,2,0,0,1,0-4H7a1,1,0,0,0,1-1V6H28Z"/><path d="M26,10.29V23.71A2.3,2.3,0,0,1,23.71,26H17a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1h2a1,1,0,0,1,0,2H18v2h5.71a.29.29,0,0,0,.29-.29V16H22a1,1,0,0,1,0-2h2V10.29a.29.29,0,0,0-.29-.29H12.29a.29.29,0,0,0-.29.29V14h4V13a1,1,0,0,1,2,0v4a1,1,0,0,1-2,0V16H12v7.71a.29.29,0,0,0,.29.29H13a1,1,0,0,1,0,2h-.71A2.3,2.3,0,0,1,10,23.71V10.29A2.3,2.3,0,0,1,12.29,8H23.71A2.3,2.3,0,0,1,26,10.29Z"/>';
var BlueprintOutlineSVG = function BlueprintOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.BlueprintOutlineSVG = BlueprintOutlineSVG;
BlueprintOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(BlueprintOutlineSVG);
exports.default = _default;